/* eslint-disable max-len */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { bookingReasonsNavigationActions, IBookingReasonsNavigation } from "../../../state/booking-reasons-navigation";
import { IPetsReasonSelection } from "../../../state/booking-reasons-navigation/booking-reasons-navigation.reducer";

export const useBookingReasonsNavigation = () => {
  const dispatch = useDispatch();
  const { petsReasonSelection, currentNavigationIndex } = useSelector((state: IRootState) => state.bookingReasonsNavigation as IBookingReasonsNavigation);

  const setPetsReasonSelection = (petsReasonSelection: IPetsReasonSelection[]) => {
    dispatch(bookingReasonsNavigationActions.setPetsReasonSelection(petsReasonSelection));
  };

  const setCurrentNavigationIndex = (currentIndex: number) => {
    dispatch(bookingReasonsNavigationActions.setCurrentNavigationIndex(currentIndex));
  };

  const setDefaultSelectionValues = () => {
    const defaultPetsSelection = petsReasonSelection.map((pet) =>
      ({ ...pet, currentSelectionState: 0 as 0, selectedReasonCategory: "", selectedReasons: [], additionalDescription: "" }));

    setCurrentNavigationIndex(0);
    setPetsReasonSelection(defaultPetsSelection);
  };

  const setDefaultNavigationValues = () => {
    const defaultNavigationValues = petsReasonSelection.map((pet) => ({ ...pet, currentSelectionState: 0 as 0 }));

    setCurrentNavigationIndex(0);
    setPetsReasonSelection(defaultNavigationValues);
  };

  const resetReasonsNavigationStore = () =>{
    dispatch(bookingReasonsNavigationActions.resetReasonsNavigationStore());
  };


  return {
    petsReasonSelection,
    currentNavigationIndex,
    setPetsReasonSelection,
    setCurrentNavigationIndex,
    setDefaultSelectionValues,
    resetReasonsNavigationStore,
    setDefaultNavigationValues,
  };
};

export default useBookingReasonsNavigation;

